<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Callcentre-Dashboard",
  path: "dashboard",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
